import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { Header } from "@components/site/Header"
import { Button } from "@components/atoms/Button"
import { cn } from "@utils/tw"
import { InsightHeader } from "@components/insight/InsightHeader"
import { HubspotForm } from "@components/atoms/HubspotForm"
import { InsightTile } from "@components/atoms/InsightTile"

export default defineView("single-insight", (props) => {
  const bodyBlocks =
    props.insight?.contentBlocks.filter((block) => block.blockName !== "acf/insight-insight-header") || []
  const isArticle = !["reports", "webinars"].includes(props.insight?.insightHeader?.type?.slug!)
  const related = props.insight?.insightHeader?.type?.insights?.nodes.filter(
    (insight) => insight?.id !== props.insight?.id,
  ) as (typeof props.insight)[] | undefined

  return (
    <div className="w-full">
      <Header noPattern barClassName={cn(!isArticle && "!bg-slate200")} />
      <div className={cn("relative w-full", !isArticle && "bg-slate200")}>
        <div className={cn("content-sized flex flex-col gap-5", !isArticle && "pb-5")}>
          <Button variant={!isArticle ? "medium" : "primary"} size="sm" href="/insights">
            Back to Insights
          </Button>
          <InsightHeader
            title={props.insight?.title || ""}
            type={props.insight?.insightHeader?.type?.insightType?.titleSingular || ""}
            typeSlug={props.insight?.insightHeader?.type?.slug || ""}
            typeUri={props.insight?.insightHeader?.type?.uri || ""}
            categories={props.insight?.insightHeader?.icategories || []}
            displayedDate={props.insight?.insightHeader?.displayedDate || ""}
            headline={props.insight?.insightHeader?.headline}
            featuredImage={props.insight?.insightHeader?.featuredImage || null}
            personnel={props.insight?.insightHeader?.personnel}
            formId={props.insight?.insightHeader?.hubspotFormId}
          />
        </div>
      </div>
      <div className={cn("relative w-full", !isArticle && "my-5 py-5")}>
        <div className={cn("content-sized md:w-cols-8 mx-auto pb-11", !isArticle && "md:!w-cols-6")}>
          <ContentBlocks blocks={bodyBlocks} />

          {!isArticle && props.insight?.insightHeader?.hubspotFormId && (
            <div className="w-full mt-9 p-5 bg-slate300 rounded-md relative">
              <a id={`register-${props.insight?.insightHeader?.hubspotFormId}`} className="absolute left-0 top-0" />
              <HubspotForm formId={props.insight?.insightHeader?.hubspotFormId} />
            </div>
          )}
        </div>

        {related && related.length > 0 && (
          <div className={cn("content-sized mx-auto", !isArticle && "md:!w-cols-6")}>
            <div className="flex items-center justify-between gap-4 mb-6 md:mb-5 flex-wrap">
              <h2 className="type-sans-xl-semibold">Related {props.insight?.insightHeader?.type?.name}</h2>
              <Button href={props.insight?.insightHeader?.type?.uri || "#"} variant="primary" size="sm">
                {`View All ${props.insight?.insightHeader?.type?.name}`}
              </Button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-4">
              {related
                .slice(0, 2)
                .map(
                  (insight, index) =>
                    insight && (
                      <InsightTile
                        key={index}
                        id={insight.id}
                        title={insight.title || "Insight Title"}
                        uri={insight.uri || "#"}
                        image={insight.insightHeader?.featuredImage || undefined}
                        type={insight.insightHeader?.type?.name || undefined}
                        typeUri={insight.insightHeader?.type?.uri || undefined}
                        theme={insight.insightHeader?.theme || undefined}
                        date={insight.insightHeader?.displayedDate || undefined}
                      />
                    ),
                )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
})
